<template>
  <div id="header" class="page-width">
    <div class="flex flex_align_center">
      <a href="/" class="flex_align_end">
        <img :src="$settings.get({ path: 'images' }).logo_bright" width="100px" class="space-between">
        <p class="tagline">Accounting</p>
      </a>
      <div class="logout-button">
        <p @click="logout">Logout</p>
      </div>
    </div>
    <div class="links flex flex_align_center">
      <div>
        <search-box type="text" placeholder="Search Applicants/Companies"></search-box>
      </div>
      <router-link v-if="isSuperAdmin" :to="{ name: 'recruiter_payments' }" :class="{ selected: $route.name == 'recruiter_payments' }">
        Recruiter Payments
      </router-link>
      <router-link v-if="isSuperAdmin" :to="{ name: 'recruiter_report', query: { offer_statuses: 'paid' } }" :class="{ selected: $route.name == 'recruiter_report' }">
        Recruiter Report
      </router-link>
      <router-link v-if="isSuperAdmin" :to="{ name: 'reports', query: { statuses: getReportsDefaultStatuses.join(','), sum_field_option: 'created_at' } }" :class="{ selected: $route.name == 'reports' }">
        Reports
      </router-link>
      <router-link v-if="isSuperAdmin" :to="{ name: 'stats' }" :class="{ selected: $route.name == 'stats' }">Stats</router-link>
      <router-link :to="{ name: 'companies' }" :class="{ selected: $route.name == 'companies' }">Companies</router-link>
      <router-link :to="{ name: 'offers', query: { sort: 'payment_deadline', statuses: 'vesting,pending_notification,notification_sent,notification_approved' } }" :class="{ selected: $route.name == 'offers' }">Offers</router-link>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import OffersHelper from '@/classes/offers_helper.js'
import SearchBox from '@/components/SearchBox'
export default {
  name: 'custom-header',
  data () {
    return {
      offers_helper: new OffersHelper()
    }
  },
  computed: {
    getReportsDefaultStatuses () {
      return this.offers_helper.getOrangeStatuses().concat(this.offers_helper.getGreenStatuses())
    },
    ...mapGetters('general', ['isSuperAdmin'])
  },
  methods: {
    logout () {
      localStorage.clear()
      window.location.href = '/'
    }
  },
  components: {
    SearchBox
  }
}
</script>
<style scoped>
  #header {
    margin-top: 20px;
    border-radius: 6px;
    padding: 25px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--color-header);
    margin-bottom: 20px;
    box-shadow: 0 12px 18px 2px rgba(34,0,51,.04),0 6px 22px 4px rgba(7,48,114,.12),0 6px 10px -4px rgba(14,13,26,.12);
  }
  .links a {
    margin-left: 20px;
  }
  .selected{
    color: var(--color-secondary) !important;
  }
  a {
    color: white;
    text-decoration: none;
  }
  .links a:hover {
    text-decoration: underline;
  }
  .tagline{
    margin-top: -7px;
    font-size: 10px;
    margin-left: 1px;
  }
  .logout-button {
    cursor: pointer;
    margin-left: 20px;
    color: white;
  }
  .logout-button:hover{
    text-decoration: underline;
  }
</style>
